import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateRight } from '@fortawesome/free-solid-svg-icons';

import './LoadMoreButton.css';

export function LoadMoreButton({ onClick }) {
  return (
    <div className="loadMoreButtonContaienrEHRPage">
      <button className="loadMoreButtonEHRPage" onClick={onClick}>
        <FontAwesomeIcon
          icon={faArrowRotateRight}
          size="sm"
          color="var(--primary-color)"
          className="icon"
        />
        Carregar mais
      </button>
    </div>
  );
}

LoadMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
